import React from 'react'
import { fetchCommunityEnabled } from '../services/communityService'

export function useCommunityEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const ok = await fetchCommunityEnabled()
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return enabled
}

